import type { JSX, ReactNode } from 'react';
import type { IChartLaneLogScale } from '@/types/PatientDashboard/PatientTimeline.types';
import {
  ChartLaneArea,
  ChartLaneRoot,
  ChartLaneSvg,
} from './ChartLane.styles';
import ChartLaneYAxisTicks from './ChartLaneYAxisTicks';

const VIEW_BOX = '0 0 100 100';

interface IProps {
  scale: IChartLaneLogScale;
  plot: ReactNode;
  children: ReactNode;
}

export default function ChartLaneFrame({ scale, plot, children }: IProps): JSX.Element {
  return (
    <ChartLaneRoot>
      <ChartLaneYAxisTicks scale={scale} />
      <ChartLaneArea>
        <ChartLaneSvg viewBox={VIEW_BOX} preserveAspectRatio="none">
          {plot}
        </ChartLaneSvg>
        {children}
      </ChartLaneArea>
    </ChartLaneRoot>
  );
}
